module.exports = "<app-compare-input *ngIf=\"doInput\"></app-compare-input>\n<app-compare-results *ngIf=\"!doInput\"></app-compare-results>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/compare/compare.component.html
// module id = 423
// module chunks = 1